import { ChevronRight } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, To } from "react-router";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatDateTime } from "~/modules/app/util/formatters";
import UserBadge from "~/modules/user/components/UserBadge";

import { ProjectReviewVisitV2ApprovalDisplayFragment } from "./fragments.generated";

type Props = {
    visit: ProjectReviewVisitV2ApprovalDisplayFragment;
    finalReportHref: To;
    showFinalReportButton: boolean;
};

export function ProjectReviewVisitV2ApprovalDisplay({ visit, finalReportHref, showFinalReportButton }: Props) {
    const { t } = useTranslation("project");

    if (!showFinalReportButton && !visit.approvedByUser) {
        return null;
    }

    return (
        <Stack
            spacing={2}
            sx={theme => ({
                padding: 2,
                backgroundColor: theme.palette.primary.dark,
                color: theme.palette.primary.contrastText,
            })}
        >
            {showFinalReportButton && (
                <Button variant="contained" component={Link} to={finalReportHref} endIcon={<ChevronRight />}>
                    {t("projectReviewVisitV2.approvalAlert.openFinalReport")}
                </Button>
            )}

            {visit.approvedByUser && visit.approvedAt && (
                <Stack columnGap={1} direction="row" flexWrap="wrap" alignItems="center">
                    <Typography variant="body2">{t("projectReviewVisitV2.approvalAlert.approvedBy")}</Typography>
                    <UserBadge
                        sx={{}}
                        names={[visit.approvedByUser.firstName, visit.approvedByUser.lastName]}
                        profilePicture={visit.approvedByUser.profilePictureMedia?.url}
                        size={25}
                        showName
                    />
                    <Typography variant="body2">
                        {t("projectReviewVisitV2.approvalAlert.on", {
                            date: formatDateTime(parseStringToDate(visit.approvedAt)),
                        })}
                    </Typography>
                </Stack>
            )}
        </Stack>
    );
}
